export const APP_ROUTES = {
  home: '/',
  login: '/login',
  inventory: '/inventory',
  locations: '/locations',
  orders: '/orders',
  settings: '/settings',
} as const

export type AppRoute = (typeof APP_ROUTES)[keyof typeof APP_ROUTES]
